// ClientMatchRow helpers — presentation helpers shared by ClientMatchCard.
// The former default-export row UI was unused (ACTION-MENUS-UX-B1-06) and
// was removed; keep only the imported formatters/labels.

const STATUS_LABELS = {
  new: "Новий",
  contacted: "Зв\u2019язалися",
  viewing: "Перегляд заплановано",
  rejected: "Відхилено",
};

const PROPERTY_TYPE_LABELS = {
  apartment: "Квартира",
  house: "Будинок",
  land: "Земельна ділянка",
  commercial: "Комерційна",
  industrial: "Промислова",
};

const CURRENCY_GLYPH = {
  USD: "$",
  EUR: "€",
  UAH: "₴",
};

export const formatMatchScorePercent = (score) => {
  if (score === null || score === undefined || score === "") return "—";
  const numeric = typeof score === "number" ? score : Number(score);
  if (!Number.isFinite(numeric)) return "—";
  return `${Math.round(numeric * 100)}%`;
};

export const formatMatchPrice = (amount, currency) => {
  if (amount === null || amount === undefined || amount === "") return "—";
  const numeric = typeof amount === "number" ? amount : Number(amount);
  if (!Number.isFinite(numeric)) return "—";
  const formatted = numeric
    .toLocaleString("uk-UA", { maximumFractionDigits: 2 })
    .replace(/\u00a0/g, " ");
  const glyph = CURRENCY_GLYPH[currency] || "";
  return `${glyph}${formatted}`.trim();
};

export const propertyTypeLabel = (propertyType) => {
  if (!propertyType) return "—";
  return PROPERTY_TYPE_LABELS[propertyType] || propertyType;
};

export const statusLabel = (statusKey) =>
  STATUS_LABELS[statusKey] || statusKey || "—";
